module.exports = __webpack_public_path__ + "img/imgStep03.6bed8a32.png";